import axios from 'axios';

class Api {
  constructor() {
    this.processing = false;
    this.search_url = '/employees-search?limit=100&query=';
  }

  search(query, not, page = null) {
    this.processing = true;

    let url = this.search_url + query;

    if (not) {
      url = `${url}&not=${not}`;
    }

    if (query === '') {
      url = `${url}&show_all=1`;
    }

    if (page) {
      url = `${url}&page=` + page;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(response => {
          this.processing = false;
          resolve(response.data);
        })
        .catch(error => {
          this.processing = false;
          reject(error.response);
        });
    });
  }
}

export default Api;
